/* eslint-disable jsx-quotes */
import React from 'react';

import './styles.css';

export default class ItemOptionManageQuestionPresentation extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            option,
            handleRemoveItemsOptionQuestion,
            handleSelectCorrectOptionQuestion,
            handleEnableItemsOptionQuestion,
            showAllTextOption,
            // handleShowAllTextOption,
            enableEditMode,
            editMode,
        } = this.props;
        return (
            <div
                className={
                    option.enabled
                        ? 'container-option'
                        : 'container-option disable-option'
                }
            >
                <span className="header">
                    <span
                        className="description"
                        onClick={() => {
                            if (option.enabled && !editMode) {
                                handleSelectCorrectOptionQuestion(option.title);
                            }
                        }}
                    >
                        <span
                            className={
                                !option.correct
                                    ? 'indicate-correct'
                                    : 'indicate-correct highlight-correct'
                            }
                        >
                            {option.correct && (
                                <span className="checkmark"></span>
                            )}
                        </span>

                        <p>{option.title}</p>
                    </span>
                    <span className="line-actions">
                        {!editMode && (
                            <React.Fragment>
                                <button
                                    className="edit-question-btn"
                                    type="button"
                                    onClick={() =>
                                        enableEditMode({
                                            title: option.title,
                                            correct: option.correct,
                                        })
                                    }
                                >
                                    Editar

                                </button>
                                <button
                                    className={ option.correct ? 'disabled-button' : 'enabled-button'}
                                    type="button"
                                    disabled={option.correct}
                                    onClick={() =>
                                        handleRemoveItemsOptionQuestion(
                                            option.title,
                                        )
                                    }
                                >
                                    Remover
                                </button>
                                <button
                                    className={ option.correct ? 'disabled-button' : 'enabled-button'}
                                    type="button"
                                    disabled={option.correct}
                                    onClick={() =>
                                        handleEnableItemsOptionQuestion(
                                            option.title,
                                            !option.enabled,
                                        )
                                    }
                                >
                                    {option.enabled ? 'Desativar' : 'Ativar'}
                                </button>
                            </React.Fragment>
                        )}
                    </span>
                </span>
                {showAllTextOption && (
                    <span className="content-question">{option.title}</span>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/manage-question/components/ItemOptionManageQuestion/ItemOptionManageQuestionPresentation.js